import { UserProfile } from '../components/UserProfile';

export function ProfilePage() {
  return <UserProfile isOwnProfile showBackButton={false} />;
}

export default ProfilePage;
